export default __webpack_public_path__ + "static/handtrace-9d7fc919aac903f5e37ba33c5295bde4.gif";